export const parseAwardTagName = (tagName: string): { awardType: string; category: string } => {
  if (!tagName || !tagName.includes('-')) {
    return {
      awardType: 'Winner',
      category: tagName || '',
    };
  }

  const parts = tagName.split('-');
  const awardType = parts[0]?.trim() || 'Winner';
  const category = parts.slice(1).join('-').trim(); // In case there are multiple "-" in the string

  return {
    awardType,
    category,
  };
};

